export default {
  title: 'Opdater {{name}}s profil',
  form: {
    name: {
      label: 'Navn',
      placeholder: 'Angiv ejerens fulde navn',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Angiv ejerens personlige e-mail',
      tooltip: 'Restaurantejerens/lederens personlige e-mail. Bruges som login til dashboardet',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne blev gemt',
  },
};
